import React, { useContext } from "react";
import ContentPageSharePublicLinksSocial from "./ContentPageSharePublicLinksSocial";
import ContentPageShareLink from "./ContentPageShareLink";
import DataContainer from "components/utility/data-container/DataContainer";
import { ShareContext } from "components/context/share/ShareContext";

export const ContentPageSharePublicLinks = () => {
	const data = useContext(ShareContext);
	const { publicLinks, selectedTab, copyLabel, copyConfirm, isMobile, analytics } = data;
	const { label, shareUrl, shareLabel, shareLabelMobile } = publicLinks;
	return (
		((selectedTab === label && !isMobile) || isMobile) && (
			<div className="content-page-share-public-links">
				<DataContainer data="shareSocialLinks">
					<ContentPageSharePublicLinksSocial
						analytics={{ action: "Share Modal", category: "Share", ...analytics }}
						shareUrl={shareUrl}
					/>
				</DataContainer>
				{shareUrl ? (
					<ContentPageShareLink
						className="content-page-share-public-links-url"
						shareUrl={shareUrl}
						shareLabel={shareLabel}
						shareLabelMobile={shareLabelMobile}
						copyLabel={copyLabel}
						copyConfirm={copyConfirm}
						analytics={{ action: "Share Modal", category: "Share", ...analytics }}
					/>
				) : null}
			</div>
		)
	);
};

export default ContentPageSharePublicLinks;
